import React, { useEffect } from 'react'
import { TextField, Grid, Box, Button } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { PartnerWithUsOneSchema } from '../../Utils/Validations'

const PartnerWithUsOne = ({ handleBack, handleComplete, partnerWithUsData, setPartnerWithUsData }) => {
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(PartnerWithUsOneSchema)
  })
  useEffect(() => {
    setValue("first_name", partnerWithUsData.first_name || "")
    setValue("last_name", partnerWithUsData.last_name || "")
    setValue("company", partnerWithUsData.company || "")
    setValue("institution_name", partnerWithUsData.institution_name || "")
  }, [])
  const onSubmit = (data) => {
    console.log(data)
    setPartnerWithUsData((prev) => ({ ...prev, first_name: data.first_name, last_name: data.last_name, company: data.company, institution_name: data.institution_name }))
    handleComplete()
  }
  return (
    <div>

      <Grid container style={{ justifyContent: "center", marginTop: 20 }} >
        <Grid sm={4} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 } }}>
          <Controller
            control={control}
            name="first_name"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label>First name</label>
                <TextField fullWidth placeholder='First name' {...field} error={errors.first_name} helperText={errors?.first_name?.message} />
              </>
            )}
          />
        </Grid>

        <Grid sm={4} xs={12} sx={{ textAlign: "left", px: { sm: 1, xs: 0 }, mt: { sm: 0, xs: 2 } }}>
          <Controller
            control={control}
            name="last_name"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label>Last name</label>
                <TextField fullWidth placeholder='Last name' {...field} error={errors.last_name} helperText={errors?.last_name?.message} />
              </>
            )}
          />
        </Grid>

        <Grid sm={4} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, mt: { sm: 0, xs: 2 } }}>
          <Controller
            control={control}
            name="company"
            render={({ field }) => (
              <>
                <label>Company</label>
                <TextField fullWidth placeholder="Company" {...field} error={errors.company} helperText={errors?.company?.message} />
              </>
            )}
          />
        </Grid>

        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 }, mt: 3 }}>
          <Controller
            control={control}
            name="institution_name"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label>Institution or Company's name</label>
                <TextField fullWidth placeholder="Institution or Company's name"  {...field} error={errors.institution_name} helperText={errors?.institution_name?.message} />
              </>
            )}
          />
        </Grid>

        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, mt: 3 }}>
          <label>Started from</label>
          <TextField
            fullWidth
            type="date"
            value={partnerWithUsData.started_from || new Date().toISOString().split('T')[0]}
            onChange={(e) => setPartnerWithUsData((prev) => ({ ...prev, started_from: e.target.value }))}
            sx={{
              "& input[type=date]::-webkit-calendar-picker-indicator": {
                filter: "invert(1)",
                opacity: 1,
                cursor: "pointer",
              },
            }}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, pb: 2 }}>
        <Button
          color="inherit"

          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default PartnerWithUsOne